/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:25
 * @LastEditTime: 2019-12-25 19:12:37
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\iWoRouter.js
 * @Description:
 */
'use strict';
angular
    .module('editingCenterIWoRouterModule', [
        'iWoFusionSignRouterModule',
        'iWoPrivilegeDraftRouterModule',
        'iWoFusionPendingRouterModule',
        'iWoDraftBoxRouterModule',
        'newspaperAwaitReviseRouterModule',
    ])
    .config([
        '$stateProvider',
        '$urlRouterProvider',
        function($stateProvider, $urlRouterProvider) {
            $stateProvider.state('front.editctr.iWo', {
                url: '/iWo',
                views: {
                    'iwo@front.editctr': {
                        templateUrl: './editingCenter/iWo/left/left_tpl.html',
                        controller: 'iWoLeftCtrl',
                    },
                    'main@front.editctr': {
                        template: '<div></div>',
                        controller: 'editingCenterIWoCtrl',
                    },
                },
            });
        },
    ]);
